export { default } from './AvatarCollection';
